<template>
  <!-- 供应商驳回卡粉横幅：Figma 1142:37555 — Add Document + Dismiss -->
  <div class="br-doc-item__reject-banner">
    <div class="br-doc-item__reject-banner-row">
      <img
        :src="iconUrl"
        class="br-doc-item__reject-banner-icon"
        width="18"
        height="18"
        alt=""
      />
      <div class="br-doc-item__reject-banner-copy">
        <div class="br-doc-item__reject-banner-text">
          <p class="br-doc-item__reject-banner-title">
            {{ $t('lbl_EMPBE_BR_List_Reject_BannerTitle') }}
          </p>
          <p v-if="rejectMessage" class="br-doc-item__reject-banner-reason">
            {{ rejectMessage }}
          </p>
          <p class="br-doc-item__reject-banner-help">
            {{ $t('lbl_EMPBE_BR_List_Reject_HelpLinePrefix') }}
            <button type="button" class="br-doc-item__help-link" @click="$emit('contact')">
              {{ $t('lbl_EMPBE_BR_Pending_ContactUs') }}
            </button>{{ $t('lbl_EMPBE_BR_Pending_HelpSuffix') }}
          </p>
        </div>
        <div class="br-doc-item__reject-banner-actions">
          <button
            type="button"
            class="br-doc-item__reject-add"
            @click="$emit('reupload')"
          >
            <feather type="plus" :size="20" />
            <span>{{ $t('lbl_EMPBE_BR_List_Reject_Resubmit') }}</span>
          </button>
          <button
            type="button"
            class="br-doc-item__reject-delete"
            @click="$emit('cancel')"
          >
            {{ $t('lbl_EMPBE_BR_List_Delete') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BR_LICENSE_ASSETS } from '../../../constants/brLicenseAssets';

export default {
  name: 'BrRejectBanner',
  props: {
    rejectMessage: { type: String, default: '' },
  },
  computed: {
    iconUrl() {
      return BR_LICENSE_ASSETS.rejectedReasonIcon;
    },
  },
};
</script>
